import {
  core_v1_Transform,
  coreV1CreateTransformMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { setClientOfOrigin } from '@/utils/setClientOfOrigin';

export const useCreateTransform = () => {
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: (data: core_v1_Transform) => {
      const dataWithClientOrigin = setClientOfOrigin(data);
      return coreV1CreateTransformMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: dataWithClientOrigin, path: { workspace } });
    },
  });
};
